import { Link } from "react-router-dom";
import MagicBento from "../components/MagicBento";
import "./TestingPageThree.css";

const bentoCards = [
  {
    id: "me",
    layout: "about",
    label: "Profile",
    title: "Creative profile",
    description:
      "Creative developer focused on motion-first UI, tactile layouts, and story-driven web experiences.",
    detailsTitle: "About me",
    details: [
      "I blend design and engineering to build playful interfaces that still feel precise.",
      "My sweet spot is the moment between concept and polish: prototyping, refining motion, and making interactions feel real.",
      "Use this section to add your full bio, press notes, or a longer creative statement.",
    ],
    highlights: [
      "Motion systems and interaction design",
      "Design to code handoff",
      "Detail-oriented prototyping",
    ],
    meta: [
      { label: "Based", value: "Toronto" },
      { label: "Focus", value: "Motion UI" },
    ],
    image:
      "https://images.unsplash.com/photo-1471879832106-c7ab9e0cee23?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Warm light over a studio desk",
    color: "rgba(255, 249, 240, 0.9)",
  },
  {
    id: "experience",
    layout: "experience",
    label: "Experience",
    title: "Studio history",
    description:
      "Collaborations across brand, product, and editorial projects.",
    detailsTitle: "Experience",
    details: [
      "2024 - Present: Independent creative developer across product and brand activations.",
      "2022 - 2024: Frontend lead on interactive marketing launches and design systems.",
      "2020 - 2022: UI engineer for motion-driven product storytelling.",
    ],
    highlights: [
      "Brand launch microsites",
      "Interactive product demos",
      "Creative tooling and prototypes",
    ],
    meta: [
      { label: "Years", value: "6+" },
      { label: "Teams", value: "Studio, product" },
    ],
    image:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "People collaborating around a table",
    color: "rgba(255, 247, 236, 0.92)",
  },
  {
    id: "skills",
    layout: "skills",
    label: "Skills",
    title: "Core toolkit",
    description: "Animation, layout, and frontend craft.",
    detailsTitle: "Toolkit",
    details: [
      "Interaction design, prototyping, and motion studies for web.",
      "Frontend engineering with React, WebGL, and creative coding tools.",
      "Storytelling through typography, layout rhythm, and subtle details.",
    ],
    highlights: [
      "React + Vite",
      "GSAP and animation systems",
      "WebGL, shaders, and canvas",
    ],
    meta: [
      { label: "Primary", value: "Frontend" },
      { label: "Tools", value: "GSAP, OGL" },
    ],
    image:
      "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Laptop with code on screen",
    color: "rgba(255, 250, 242, 0.9)",
  },
  {
    id: "favorites",
    layout: "favorites",
    label: "References",
    title: "Favorite cues",
    description: "Typography, cinematic lighting, and tactile UI patterns.",
    detailsTitle: "Favorites",
    details: [
      "Graphic systems that feel physical: paper textures, light leaks, and soft gradients.",
      "Fonts that balance warmth with structure, plus motion that respects the grid.",
      "Swap these with your favorite tools, playlists, or visual references.",
    ],
    highlights: [
      "Typographic scale studies",
      "Experimental layouts",
      "Lighting references",
    ],
    meta: [
      { label: "Palette", value: "Warm neutrals" },
      { label: "Inspo", value: "Editorial" },
    ],
    image:
      "https://images.unsplash.com/photo-1487014679447-9f8336841d58?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Creative workspace with notebooks",
    color: "rgba(255, 245, 233, 0.9)",
  },
  {
    id: "hobby",
    layout: "hobby",
    label: "Off hours",
    title: "Hobby stack",
    description: "Camera walks, espresso experiments, and long rides.",
    detailsTitle: "Hobbies",
    details: [
      "Exploring the city with a camera and collecting light studies for projects.",
      "Dialing in espresso recipes and comparing notes with friends.",
      "Long rides for fresh air and new ideas.",
    ],
    highlights: ["Film photography", "Cycling routes", "Coffee rituals"],
    meta: [
      { label: "Reset", value: "Weekend rides" },
      { label: "Fuel", value: "Espresso" },
    ],
    image:
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1400&q=80",
    imageAlt: "Warm sunset over a landscape",
    color: "rgba(255, 248, 238, 0.9)",
  },
];

export default function TestingPageThree() {
  return (
    <div className="testing3-page">
      <header className="testing3-header">
        <Link to="/" className="testing3-header__logo">
          DYLAN CHEN ZHEN
        </Link>
      </header>

      <main className="testing3-main">
        <section className="testing3-hero">
          <span className="testing3-hero__eyebrow">Testing 3</span>
          <h1 className="testing3-hero__title">Magic Bento Page Template</h1>
          <p className="testing3-hero__subtitle">
            A richer editorial-style bento layout with layered cards, warm glow
            interactions, and an expanded detail sheet for each tile.
          </p>
          <div className="testing3-hero__meta">
            <span>Glow spotlight</span>
            <span>Interactive cards</span>
            <span>Responsive modal sheet</span>
          </div>
        </section>

        <section className="testing3-bento">
          <div className="testing3-bento__frame">
            <MagicBento
              cards={bentoCards}
              glowColor="255, 140, 66"
              enableTilt={false}
            />
          </div>
          <p className="testing3-bento__note">
            Tip: Hover across cards to move the spotlight, then click any tile
            to open the full details panel.
          </p>
        </section>
      </main>
    </div>
  );
}
